<template>
  <div>
    <el-row>
      <el-col :span="8">
        <span>Plot data of</span>
        <el-radio-group v-model="plotOrganism" size="small" style="margin-left: 10px">
          <el-radio-button label="current">Current Organism</el-radio-button>
          <el-radio-button label="all">All selected Organisms</el-radio-button>
        </el-radio-group>
      </el-col>

      <el-col :span="8" align="left">
        <el-select v-model="plotOptions.selected" collapse-tags multiple filterable
          placeholder="Select repeats" style="width: 90%">
          <el-option-group v-for="group in repeatsMultiSelectOptions" :key="group.label" :label="group.label">
            <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>
      </el-col>

      <el-col :span="2" align="left">
        <span>Data type: </span>
          <el-radio-group v-model="plotOptions.datatype" size="small">
            <el-radio style="display: block; width: 110px; margin-top: 5px" label="bases" border>Bases</el-radio><br>
            <el-radio style="display: block; width: 110px; margin-top: 5px;" label="frequency" border>Frequency</el-radio>
          </el-radio-group>
      </el-col>

      <el-col :span="6" align="left">
            Group by length: <el-switch style="margin-left: 10px" v-model="plotOptions.groupByLength"></el-switch>
        </el-col>

    </el-row>

    <el-row v-if="plotOrganism === 'current'" style="margin-top: 20px">
      <modal-unit-pie-distribution height="70vh" :freqData="barFrequencyData[store.species.order.indexOf(store.species.current)]"></modal-unit-pie-distribution>
    </el-row>
    <el-row v-if="plotOrganism === 'all'">
    </el-row>
  </div>
</template>

<script>
  import { store } from '../scripts/store.js'
  import ModalUnitPieDistribution from '../components/ModalUnitPieDistribution.vue'
  import { repeatsMultiSelectOptions } from '../scripts/repeatsMultiSelectOptions.js'
  import { repeatFrequency } from '../scripts/utils.js'
  import { repeats } from '../scripts/repeats.js'


  export default {
    name: 'ModalBarFrequency',
    components: {
      ModalUnitPieDistribution
    },
    data() {
      return {
        store: store,
        plotOrganism: "current",
        repeatsMultiSelectOptions: repeatsMultiSelectOptions,
        plotOptions: {
          selected: ["A", "C", "AC", "AG", "AT", "CG"],
          datatype: "bases",
          groupByLength: true
        }
      }
    },
    computed: {

      pieDistributionData: function(){
        
        let parameters = this.plotOptions;
        let bardata = [];
        const organisms = this.store.species.order;
        const info = this.store.info;
        
        organisms.forEach((o, i) => {
          let freqData = [];
          const orginfo = info.filter(a => { return a.OrgInfo.MSDBID === o; })[0];
          const organismName = orginfo.OrgInfo.OrganismName;
          const genomeSize = parseInt(orginfo.GenomeInfo.GenomeSize);
          const plotdata = orginfo.RepInfo.PlotData;
          const repeats = Object.keys(plotdata);
          if (parameters.type === "sort") {
            freqData = repeatFrequency(plotdata, parameters.sort.num, parameters.sort.order);
          }
          else if (parameters.type === "repeat") {
            const sort = (parameters.repeat.sort) ? "descending" : "kmer";
            freqData = repeatFrequency(plotdata, parameters.repeat.selected, sort)
          }
          if (parameters.datatype === "density"){
            freqData.forEach( (d, j) => {
              const freq = freqData[j].value;
              let density = ((freq/genomeSize) * 1000000).toFixed(2);
              freqData[j].value = density;
            })
          }
          bardata.push({ title: organismName, data: freqData});
        })

        if ((parameters.groupByRepeat) && (this.plotOrganism != "current") && (parameters.type == "repeat")) { 
          
          const selectedRepeats = parameters.repeat.selected;
          let freqData = [];
          selectedRepeats.forEach((r, i) => {
            freqData.push({ title: r, data: [] });
            bardata.forEach(b => {
              const name = b.title;
              const value = b.data.filter(d => {return d.name === r;})[0].value;
              freqData[i]['data'].push({name: name, value: value});
            })
          })
          bardata = freqData;
        }

        return bardata;
      }

    }
  }
</script>